import { render, staticRenderFns } from "./DemandeAcces.vue?vue&type=template&id=7585c366&%3Akey=componentKey&"
import script from "./DemandeAcces.vue?vue&type=script&lang=js&"
export * from "./DemandeAcces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports